// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody } from '@/assets/theme/fonts'

export default function HowWeWorkSection() {
  const { t } = useTranslation('technology')

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader eyebrow={t('how.eyebrow')} title={t('how.title')} />

      <Box sx={{ maxWidth: '52rem' }}>
        {[t('how.p1'), t('how.p2'), t('how.p3')].map(paragraph => (
          <Typography
            key={paragraph}
            component="p"
            fontSize={getFontBody()}
            sx={{
              lineHeight: 1.7,
              color: themeColors.gray.defaultText,
              marginBottom: '1rem',
              '&:last-of-type': { marginBottom: 0 }
            }}
          >
            {paragraph}
          </Typography>
        ))}

        <Typography
          component="p"
          fontSize={getFontBody()}
          sx={{
            marginTop: '2rem',
            paddingLeft: '1rem',
            borderLeft: `3px solid ${themeColors.success.main}`,
            lineHeight: 1.7,
            fontWeight: 500,
            color: themeColors.gray.dark
          }}
        >
          {t('how.note')}
        </Typography>
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
